import { ReasonDialog } from "@amber/ui";
import type { InvitationRow } from "../../contracts/index";
import { accessCommands } from "../queries";
import { AFTER_ACCESS_CHANGE } from "../keys";

export function RevokeInvitationDialog({ invitation, onClose }: { invitation: InvitationRow; onClose: () => void }) {
  return (
    <ReasonDialog
      title="Revoke this invitation?"
      confirm="Revoke"
      danger
      success="Invitation revoked"
      onClose={onClose}
      invalidate={AFTER_ACCESS_CHANGE}
      run={(reason, csrf) => accessCommands.revokeInvitation(invitation.id, reason, csrf)}
    >
      The link for <b>{invitation.email}</b> stops working. You can invite the address again later.
    </ReasonDialog>
  );
}
